module.exports = __webpack_public_path__ + "img/thumb-chinese-mapo-tofu-met-kip.919e1eac.jpeg";